//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import Pagination from "~/components/common/Pagination.vue";

let timeOutSearch = null;
export default BaseCmsBlock.extend({
  name: "ServicesBlock",

  fetch: async function () {
    await this.initSearch();
    await this.getServices();
  },

  data: function () {
    return {
      services: [],

      page: 1,
      search: "",
      isLoading: false,

      totalCount: 0,
      totalPages: 1,
    }
  },

  computed: {
    paginationLinkPagination: function () {
      const search = [
        `page=$page`,
        Boolean(this.search.length >=2) && `search=${ this.search }`
      ].filter((t) => !!t).join('&');
      return ['/services', search].join('?')
    }
  },

  components: {
    Pagination
  },

  watch: {
    search: function () {
      clearTimeout(timeOutSearch);
      this.isLoading = true;
      timeOutSearch = setTimeout(async () => {
        await this.getServices();
      }, 1000);
    }
  },

  methods: {
    getServices: async function () {
      this.isLoading = true;
      const search = [
        `per-page=39`,
        `page=${ this.page }`,
        Boolean(this.search.length >=2) && `search=${ this.search }`
      ].filter((t) => !!t).join("&");
      const response = await this.$api.agent.transport.get(['/service', search].join('?'))
        .then((res) => res || null)
        .catch(() => null);

      const services = response?.data || [];
      const totalCount = Number.parseFloat(response?.headers?.['x-pagination-total-count'] || '0');
      const totalPages = Number.parseFloat(response?.headers?.['x-pagination-page-count'] || '1');

      this.services = services;
      this.totalCount = totalCount;
      this.totalPages = totalPages;
      this.isLoading = false;

      await this.setSearch();
    },

    setSearch: async function () {
      if (!process.client) {
        return
      }

      let search = [
        Boolean(this.page > 1) && `page=${ this.page }`,
        Boolean(this.search.length >=2) && `search=${ this.search }`
      ].filter((t) => !!t).join('&');
      window.history.replaceState(null, null, [
        window.location.pathname,
        search
      ].filter((t) => !!t).join('?'));
    },
    initSearch: async function () {
      const query = this.$route?.query || {};
      if (query?.page) {
        this.page = query?.page;
      }
      if (query?.search) {
        this.search = query?.search;
      }
    },

    changePage: async function (page) {
      this.page = page;
      await this.getServices();
    },
  }
});
